import { render, staticRenderFns } from "./PrimaryBaseCta.vue?vue&type=template&id=542a8f68&scoped=true&"
import script from "./PrimaryBaseCta.vue?vue&type=script&lang=js&"
export * from "./PrimaryBaseCta.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryBaseCta.vue?vue&type=style&index=0&id=542a8f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a8f68",
  null
  
)

export default component.exports